import { CoolingRegimeProductGroupDetails } from "./CoolingRegimeProductGroupDetails";
import type { DetailTab } from "../DetailDrawer";

export const getCoolingRegimeProductGroupDetailTabs = (
  productGroupCode: string,
): DetailTab[] => {
  return [
    {
      label: "Koelregime",
      content: (
        <CoolingRegimeProductGroupDetails productGroupCode={productGroupCode} />
      ),
    },
  ];
};
